(function () {
  function initReviewGallery(root) {
    if (!root || root.dataset.trgInit === '1') return;
    var track = root.querySelector('[data-trg-track]');
    if (!track) return;
    root.dataset.trgInit = '1';

    var dots = root.querySelectorAll('[data-trg-dot]');
    var prev = root.querySelector('[data-trg-prev]');
    var next = root.querySelector('[data-trg-next]');

    function step() {
      var cards = track.children;
      if (!cards.length) return track.clientWidth;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return cards[0].offsetWidth + gap;
    }

    function updateState() {
      var cards = track.children;
      if (!cards.length) return;
      var s = step();
      var active = Math.round(track.scrollLeft / s);

      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === active);
      });

      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      if (prev) prev.hidden = track.scrollLeft <= 1;
      if (next) next.hidden = track.scrollLeft >= maxScroll;
    }

    track.addEventListener('scroll', updateState, { passive: true });

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(this.dataset.trgDot, 10);
        var cards = track.children;
        if (cards[idx]) {
          cards[idx].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        }
      });
    });

    window.addEventListener('resize', updateState, { passive: true });
    updateState();
  }

  function initAll() {
    document.querySelectorAll('.trinsic-review-gallery').forEach(initReviewGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.trinsic-review-gallery');
    if (root) {
      root.dataset.trgInit = '';
      initReviewGallery(root);
    }
  });
})();
